/** @file Circumcircle test for Delaunay flips over points addressed by index in a flat array. */

/** > 0 when d is strictly inside the circumcircle of the counter-clockwise triangle (a, b, c); 0 when cocircular. */
export function inCircle(p: ArrayLike<number>, a: number, b: number, c: number, d: number): number {
  const dx = p[2 * d] ?? 0;
  const dy = p[2 * d + 1] ?? 0;
  const adx = (p[2 * a] ?? 0) - dx;
  const ady = (p[2 * a + 1] ?? 0) - dy;
  const bdx = (p[2 * b] ?? 0) - dx;
  const bdy = (p[2 * b + 1] ?? 0) - dy;
  const cdx = (p[2 * c] ?? 0) - dx;
  const cdy = (p[2 * c + 1] ?? 0) - dy;
  const ad = adx * adx + ady * ady;
  const bd = bdx * bdx + bdy * bdy;
  const cd = cdx * cdx + cdy * cdy;
  return adx * (bdy * cd - bd * cdy) - ady * (bdx * cd - bd * cdx) + ad * (bdx * cdy - bdy * cdx);
}
